module.exports = __webpack_public_path__ + "fonts/IstokWeb-Italic.49e20af5.eot";